import { ensureString } from 'ensure-string';
import { Analysis } from '../index.js';
import { parseTAInstruments } from "./parser/parseTAInstruments.js";
export function fromTAInstruments(arrayBuffer) {
    const text = ensureString(arrayBuffer);
    const analysis = new Analysis();
    const parsed = parseTAInstruments(text);
    analysis.pushSpectrum({
        x: {
            data: parsed.data.temperature,
            isDependent: true,
            label: 'Program temperature [°C]',
        },
        y: {
            data: parsed.data.weight,
            isDependent: true,
            label: 'Weight [mg]',
        },
        t: {
            data: parsed.data.time,
            isDependent: false,
            label: 'Time [min]',
        },
    }, { dataType: 'TGA', title: parsed.meta.sampleName, meta: parsed.meta });
    return analysis;
}
//# sourceMappingURL=fromTAInstruments.js.map